module.exports = __webpack_public_path__ + "img/symbol_3.869f091f.png";